import * as React from "react";

import { componentCategories, components } from "../_Generated/Pages";
import { ComponentTiles } from "../Components/ComponentTiles";

export default class ExperimentalComponentsPage extends React.Component {
    public render(): JSX.Element | null {
        return (
            <div className="flex-column flex-grow">
                <h1 className="page-title">Experimental components</h1>
                <h4>Experimental components from the azure-devops-ui-experimental package</h4>
                <ComponentTiles
                    components={components}
                    categories={componentCategories.filter(c => c.page === "experimental")}
                    searchPlaceholder="Search features"
                />
            </div>
        );
    }
}
